import { render, staticRenderFns } from "./CustomerStandardMatchVolunteer.vue?vue&type=template&id=73bd42ee"
import script from "./CustomerStandardMatchVolunteer.vue?vue&type=script&lang=ts"
export * from "./CustomerStandardMatchVolunteer.vue?vue&type=script&lang=ts"
import style0 from "./CustomerStandardMatchVolunteer.vue?vue&type=style&index=0&id=73bd42ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports